<template>
	<div :class="['icon-info-header', elementClasses]">
		<BaseIcon
			class="icon-info-header__icon"
			:name="icon"
		/>
		<span
			class="icon-info-header__title"
			v-text="title"
		/>
	</div>
</template>
<script lang="ts" setup>
import BaseIcon from '@lmt-rpb/BaseIcon/BaseIcon.vue';
import { computed } from 'vue';

interface Props {
	icon: string,
	title: string,
	size?: 'small' | 'medium',
}

const props = withDefaults(defineProps<Props>(), {
	size: 'small',
});

const elementClasses = computed(() => ({
	[`icon-info-header--${props.size}`]: props.size,
}));

</script>

<style lang="scss" scoped>
.icon-info-header {
	display: flex;
	align-items: center;
	gap: 0.8rem;
	color: $color-text;
	font-family: $font-family;

	&__icon {
		fill: currentcolor;
		max-width: 2rem;
		max-height: 2rem;
	}

	&__title {
		font-size: $font-small-1;
		font-weight: $font-weight-semibold;
		line-height: 2.7rem;
	}

	&--small {
		.icon-info-header__title {
			font-size: $font-small-2;
		}
	}

	&--medium {
		.icon-info-header__title {
			font-size: $font-medium-3;
			line-height: 3.06rem;
		}
	}

	@media screen and (min-width: $breakpoint-small) {
		&--small {
			.icon-info-header__title {
				font-size: $font-small-1;
			}
		}
	}
}
</style>
